import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'acabim-admin-financial-details',
    templateUrl: './financial-details.component.html',
    styleUrls: ['./financial-details.component.scss']
})
export class FinancialDetailsComponent implements OnInit {
    @Input() detailData?: any;
    @Input() classId?: any;
    @Input() classes: any[] = [];

    // tslint:disable-next-line:no-output-native
    @Output() close = new EventEmitter<string>();
    index = 0;

    constructor() {
    }

    ngOnInit(): void {
    }

    closeModal($event: string) {
        this.close.emit($event);
    }

    selectTab($event: any) {

    }
}
